(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-cardsave"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot(root) {
    if (root.dataset.scCsReady) return;
    root.dataset.scCsReady = '1';

    var out = root.querySelector('[data-out]');
    var outImg = root.querySelector('[data-outimg]');
    var dl = root.querySelector('[data-dl]');
    var btn = root.querySelector('[data-save]');
    var nameEl = root.querySelector('[data-name]');
    var titleEl = root.querySelector('[data-title]');
    var note = root.querySelector('[data-note]');

    // The card is addressed by the link in the welcome email, so the holder's
    // name travels in the query string rather than in storage: the email is
    // opened on whatever device happens to be to hand.
    var q = new URLSearchParams(window.location.search);
    var who = (q.get('n') || '').trim();
    var what = (q.get('t') || '').trim();

    // The title never reaches the email -- Omnisend does not hold it -- so the
    // link only carries the name. On the device the card was claimed from it is
    // still in storage under the section's own key, which is worth reading:
    // most people open the welcome mail on the phone they signed up with.
    if (!what) {
      try {
        for (var i = 0; i < window.localStorage.length; i++) {
          var k = window.localStorage.key(i);
          if (k && k.indexOf('sc-crew-') === 0) {
            var saved = JSON.parse(window.localStorage.getItem(k));
            if (saved && saved.t) { what = saved.t; break; }
          }
        }
      } catch (err) {}
    }

    if (who) nameEl.textContent = who;
    if (what) titleEl.textContent = what;

    root.addEventListener('click', function (e) {
      if (!e.target.closest('[data-save]')) return;
      save();
    });

    function save() {
      var art = root.dataset.art;
      if (!art) return fail();

      var stage = root.querySelector('.sc-cs__stage');
      var W = parseInt(root.dataset.w, 10) || 1400;
      var img = new Image();
      img.crossOrigin = 'anonymous';

      img.onerror = fail;
      img.onload = function () {
        try {
          var H = Math.round(W * (img.naturalHeight / img.naturalWidth));
          var c = document.createElement('canvas');
          c.width = W;
          c.height = H;
          var ctx = c.getContext('2d');
          ctx.drawImage(img, 0, 0, W, H);

          // Mirror the on-screen offset proportionally, so what is downloaded
          // matches what the holder was just looking at.
          var scale = W / stage.getBoundingClientRect().width;
          var shift = (parseFloat(getComputedStyle(root).getPropertyValue('--who-y')) || 0) * scale;

          var fam = getComputedStyle(titleEl).fontFamily || 'Georgia, serif';
          ctx.fillStyle = getComputedStyle(titleEl).color;
          ctx.textAlign = 'center';

          var nameSize = Math.round(W * 0.026);
          var titleSize = Math.round(W * 0.040);
          var mid = H / 2 + shift;

          ctx.font = '400 ' + nameSize + 'px ' + fam;
          ctx.fillText(nameEl.textContent, W / 2, mid);
          ctx.font = '400 ' + titleSize + 'px ' + fam;
          ctx.fillText(titleEl.textContent, W / 2, mid + titleSize * 1.45);

          // Showing the finished PNG in the page beats forcing a download:
          // on iOS a download attribute does nothing useful, whereas a plain
          // image can be long-pressed straight into the camera roll.
          c.toBlob(function (blob) {
            if (!blob) return fail();
            var url = URL.createObjectURL(blob);
            outImg.src = url;
            dl.href = url;
            out.hidden = false;
            stage.hidden = true;
            btn.hidden = true;
            try { out.scrollIntoView({ block: 'center' }); } catch (e2) {}
          }, 'image/png');
        } catch (err) {
          // A tainted canvas throws here rather than returning empty.
          fail();
        }
      };

      img.src = art;
    }

    function fail() { if (note) note.hidden = false; }
  }

  function init() { document.querySelectorAll('.sc-cs').forEach(boot); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-society"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot(root) {
    if (root.dataset.scSocReady) return;
    root.dataset.scSocReady = '1';

    var card    = root.querySelector('[data-card]');
    var nameEl  = root.querySelector('[data-name]');
    var titleEl = root.querySelector('[data-title]');
    var panel   = root.querySelector('[data-panel]');
    var ptitle  = root.querySelector('[data-panel-title]');
    var note    = root.querySelector('[data-note]');
    var actions = root.querySelector('[data-actions]');
    var member  = root.querySelector('[data-member]');
    var done    = root.querySelector('[data-done]');
    var nameIn  = root.querySelector('[data-input-name]');

    // Every title the Crew hands out: the section's own (the blocks) plus
    // each "[Role] of [Domain]" from the snippet sc-crew-titles, which
    // carries the same lists the Worker uses.
    var titles = [];
    try { titles = JSON.parse(root.querySelector('[data-titles]').textContent); } catch (e) {}
    var parts = null;
    try { parts = JSON.parse(root.querySelector('[data-title-parts]').textContent); } catch (e) {}
    if (parts && parts.roles && parts.domains) {
      parts.roles.forEach(function (r) {
        parts.domains.forEach(function (d) { titles.push(r + ' of ' + d); });
      });
    }
    var have = {};
    titles = titles.filter(function (t) { if (!t || have[t]) return false; have[t] = true; return true; });
    if (!titles.length) titles = ['Crew Member'];

    var KEY  = 'sc-crew-' + root.id;
    var turns = 0;
    var idx   = Math.floor(Math.random() * titles.length);

    // Shuffle deals from a deck: no title comes back until every other one
    // has been shown.
    var deck = [];
    function deal() {
      if (!deck.length) {
        for (var i = 0; i < titles.length; i++) if (i !== idx) deck.push(i);
      }
      var k = Math.floor(Math.random() * deck.length);
      var pick = deck[k];
      deck[k] = deck[deck.length - 1];
      deck.pop();
      return pick;
    }

    var slow = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function paintTitle() {
      titleEl.textContent = titles[idx];
      if (ptitle) ptitle.textContent = titles[idx];
      if (note) note.value = titles[idx];
    }

    paintTitle();

    // The card rests on its front at 180deg. The first shuffle sweeps to
    // 360deg -- a half turn that reveals the name side -- and every shuffle
    // after that adds a whole turn, landing on the same face again. The title
    // is swapped at the halfway point, while the other face is the one on
    // screen. setTimeout rather than a transition event: the swap must happen
    // even where the transition never fires (reduced motion, backgrounded tab).
    function shuffle() {
      idx = titles.length > 1 ? deal() : 0;
      turns += 1;
      if (slow) { card.style.transform = 'rotateY(' + (turns * 360) + 'deg)'; paintTitle(); return; }
      card.style.transform = 'rotateY(' + (turns * 360) + 'deg)';
      setTimeout(paintTitle, 380);
    }

    function openPanel() {
      panel.hidden = false;
      root.classList.add('is-claiming');
      if (nameIn) { try { nameIn.focus(); } catch (e) {} }
    }

    function closePanel() {
      panel.hidden = true;
      root.classList.remove('is-claiming');
    }

    function claimed(who, what) {
      nameEl.textContent = who;
      idx = titles.indexOf(what);
      if (idx < 0) { idx = 0; titles.unshift(what); }
      paintTitle();

      // A claimed card is already turned to its back; snap rather than spin,
      // so a returning visitor does not watch it flip on every page load.
      turns = 1;
      card.style.transition = 'none';
      card.style.transform = 'rotateY(360deg)';
      void card.offsetWidth;
      card.style.transition = '';

      root.classList.add('is-done');
      closePanel();
      if (actions) actions.hidden = true;
      if (member) member.hidden = true;
      if (done) done.hidden = false;
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-shuffle],[data-claim],[data-close],[data-restore]');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-shuffle')) return shuffle();
      if (t.hasAttribute('data-claim'))   return openPanel();
      if (t.hasAttribute('data-close'))   return closePanel();
      if (t.hasAttribute('data-restore')) {
        var saved = read();
        if (saved) claimed(saved.n, saved.t); else openPanel();
      }
    });

    // Shopify's customer form posts and reloads, so the name has to survive the
    // round trip on the client; it is the visitor's own name on their own
    // machine, which is what localStorage is for.
    function read() {
      try { return JSON.parse(window.localStorage.getItem(KEY)); } catch (e) { return null; }
    }

    var form = root.querySelector('form');
    var mailIn = form && form.querySelector('input[type="email"]');
    var handedOff = false;

    if (form) {
      form.addEventListener('submit', function (e) {
        var who = (nameIn && nameIn.value || '').trim();
        var what = titles[idx];

        try {
          window.localStorage.setItem(KEY, JSON.stringify({ n: who, t: what }));
        } catch (err) {}

        if (handedOff) return;

        // Omnisend has to learn the title before Shopify's webhook adds the
        // crew tag, because that tag is what fires the welcome automation.
        // So the write is awaited before the form navigates away. The race
        // guarantees a slow or dead endpoint can never block a sign-up:
        // worst case the card falls back to its generic wording.
        var call = identify(who, what);
        if (!call) return;

        e.preventDefault();
        handedOff = true;

        var done = false;
        function go() { if (!done) { done = true; form.submit(); } }
        call.then(go).catch(go);
        setTimeout(go, 2500);
      });
    }

    // Posts to our own worker, which writes the title to Omnisend with the API
    // key held server-side. The storefront SDK cannot do this: identifyContact
    // accepts customProperties and silently drops them.
    function identify(who, what) {
      var mail = mailIn && mailIn.value ? mailIn.value.trim() : '';
      var url = root.dataset.endpoint;
      if (!mail || !url) return null;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: mail, name: who, role: what })
      });
    }

    // Shopify redirects the customer form back with ?customer_posted=true.
    var prior = read();
    if (prior && prior.n) claimed(prior.n, prior.t);
  }

  function init() {
    document.querySelectorAll('.sc-soc2').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
